import type { QueryClient } from '@tanstack/react-query';

/**
 * Hub /hubs/sistema (01 §6.2, 05 §7.5): dicionarioAlterado e recursosAlterados invalidam esquema, menu e índice;
 * notificacao atualiza o sino. Queda de conexão é silenciosa: o próximo request mostra o estado real.
 */
export function conectarTempoReal(cliente: QueryClient): () => void {
  let parar: (() => void) | null = null;
  let cancelado = false;
  // Cliente SignalR fora do chunk inicial (07 §6.1): carrega depois que a sessão existe.
  void import('@microsoft/signalr').then((s) => {
    if (cancelado) return;
    parar = iniciar(s, cliente);
  });
  return () => {
    cancelado = true;
    parar?.();
  };
}

function iniciar({ HubConnectionBuilder, LogLevel }: typeof import('@microsoft/signalr'), cliente: QueryClient): () => void {
  const conexao = new HubConnectionBuilder().withUrl('/hubs/sistema', { headers: { 'X-Persona-Csrf': '1' } }).withAutomaticReconnect([0, 2000, 5000, 10000, 30000]).configureLogging(LogLevel.Warning).build();
  const invalidarNavegacao = () => {
    void cliente.invalidateQueries({ queryKey: ['esquema'] });
    void cliente.invalidateQueries({ queryKey: ['menu'] });
    void cliente.invalidateQueries({ queryKey: ['indice'] });
    void cliente.invalidateQueries({ queryKey: ['inicio'] });
  };
  conexao.on('dicionarioAlterado', invalidarNavegacao);
  conexao.on('recursosAlterados', invalidarNavegacao);
  conexao.on('licencaAlterada', () => void cliente.invalidateQueries({ queryKey: ['inicio'] }));
  conexao.on('notificacao', () => void cliente.invalidateQueries({ queryKey: ['notificacoes'] }));
  void conexao.start().catch(() => undefined);
  return () => void conexao.stop().catch(() => undefined);
}
